export function getSharingInfoFailedSharingData(sharingData) {
    return sharingData.filter(function (x) { return didGetSharingInfoFail(x); });
}
function didGetSharingInfoFail(sharingData) {
    return sharingData.sharingInfo && !sharingData.sharingInfo.getSharingInfoSucceeded;
}
//# sourceMappingURL=getSharingInfoFailedSharingData.js.map